const jumpPageUrl = () => {
    const liveUrl = location.href.split('?')?.[0] || '';
    const urlSplit = liveUrl.split('/') || [];

    urlSplit.pop();
    const hostUrl = urlSplit.join('/');

    return hostUrl;
};

export const LinkType = 'web';

export const ListUrl = `${jumpPageUrl()}/list`;

export const IndexUrl = `${jumpPageUrl()}/index`;

export const ResultUrl = `${jumpPageUrl()}/result`;

export const shadow = 'https://x0.ifengimg.com/ucms/2022_08/C8E968B3ECD4624991D795D943FE40ADED5D6151_size2_w346_h18.png';

export const indexCommentConfig = {
    docUrl: 'votenew_690647558728870297612',
    docName: '315财经投票_首页',
};

export const indexCommentConfig2025 = {
    docUrl: '2025finace315votehome',
    docName: '2025年315财经投票_首页',
};

export const indexCommentConfig2026 = {
    // docUrl: '2026finace315votehome',
    docUrl: 'https://ishare.ifeng.com/loc/2026/315vote/index',
    docName: '2026年315财经投票_首页',
};


export const qqShareCofig = {
    title: '315凤凰网财经企业打分台',
    img: 'https://x0.ifengimg.com/fe/custom/2024_03_11/6e01902a7b8822a6350df3e7ffaf0fc.7c671797fb05.jpg',
    desc: '给服务过您的企业打个分吧！16大消费领域，等你来投！',
    url: 'https://ishare.ifeng.com/loc/2024/315vote/index',
    cb: () => {
        console.log('分享成功');
    },
  };

  export const qqShareCofig2 = {
    title: '315投诉大调查！寻找你身边的消费陷阱',
    img: 'https://x0.ifengimg.com/ucms/2025_11/467AC6B56A54825B977AC9B58FA0EB871B165D95_size33_w300_h300.jpg',
    desc: '哪些是你消费中遇到的问题，13大消费领域负面案例，等你来投！',
    url: 'https://ishare.ifeng.com/loc/2025/315vote/index',
    cb: () => {
        console.log('分享成功');
    },
  };

export const qqShareCofig2026 = {
    title: '315投诉大调查！寻找你身边的消费陷阱',
    img: 'https://x0.ifengimg.com/ucms/2026_11/63B2B3ED1F9F2120339CF6E2AD95FD264DF4562B_size123_w300_h300.png',
    desc: '哪些是你消费中遇到的问题，11大消费领域负面案例，等你来投！',
    url: 'https://ishare.ifeng.com/loc/2026/315vote/index',
    cb: () => {
        console.log('分享成功');
    },
  };
